var map = {
  "./en/base": [
    "27821",
    [
      7856,
      5445,
      4660,
      2928,
      8824,
      2867,
      7033,
      4755,
      889
    ]
  ],
  "./nb/base": [
    "20908",
    [
      9983,
      1668,
      2967,
      9165,
      2395,
      1790,
      7690,
      9287,
      8752
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids[1].map(function(chunkId) { return __webpack_require__.e(chunkId); })).then(function() { return __webpack_require__(id); });
}

__rspack_async_context.keys = function() { return Object.keys(map); };
__rspack_async_context.id = 39907;
module.exports = __rspack_async_context;
